
export default {
  props: {
    value: Boolean,
    id: String,
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    active: {
      get() {
        return this.value;
      },
      set(val: boolean) {
        this.$emit("input", val);
      },
    },
  },
};
